import { render, staticRenderFns } from "./PollContentWrapper.vue?vue&type=template&id=1156899e&scoped=true&"
import script from "./PollContentWrapper.vue?vue&type=script&lang=js&"
export * from "./PollContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PollContentWrapper.vue?vue&type=style&index=0&id=1156899e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156899e",
  null
  
)

export default component.exports